import { Component, Mixins, Prop, Ref } from 'vue-property-decorator'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import GridHeader from '@/components/GridHeader.vue'
import { LaboratoryStatisticalAnalysisSidebarDateInput } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.model'
import { BModal } from 'bootstrap-vue'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisDossiersDatasourceResponsesDetailTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import commonCaseServices from '@/api/resources/common/commonCaseServices'
import { registryCasePrintService } from '@/modules/printModule/services/registry-case-print-service'
import { StatisticalAnalysisIncidentsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/incidents-dossier/incidents-dossier.model'
import { StatisticalAnalysisHandlerDatasourceIncidentsDossierGeneralList } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-incidents-dossier/statistical-analysis-handler-datasource-incidents-dossier-external-general-list'
import { StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.dto'
import { initialStatisticAnalysisExternalViewIncidentsStatisticsState, StatisticAnalysisExternalViewIncidentsStatisticsState } from '@/modules/statistical-analysis-module/components/statistical-analysis-external-views/statistical-analysis-external-views-incidents/statistical-analysis-external-views-incidents-statistics.model'
import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { EntityIdentifiersRequest } from '@/shared/models/http/http.model'
import { GridColumnRequest, ReportGridRequest } from '@/api/services/common.dto'
import { incidentsStatisticsDossierService } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.service'
import BaseCrudInfiniteServerSideComponent from '@/shared/resources/base-crud-infinite-side.component'
import { AgGridCallbackEvent } from '@/shared/models/ag-grid.model'
import { StatisticalAnalysisDatasourceExternalDetail } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-datasource'
import { includes } from 'lodash'
import { AxiosResponse } from 'axios'
import { CommonExportType } from '@/api/resources/common/shared/models/common.models'
import { Formatter } from '@/filters/formatter'
import { GridOptions } from '@ag-grid-enterprise/all-modules'

@Component({
    components: {
        VtGrid,
        GridDisplayOptions,
        GridHeader
    }
})
export default class StatisticAnalysisExternalViewIncidentsStatistics extends Mixins<BaseCrudInfiniteServerSideComponent<StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent>>(BaseCrudInfiniteServerSideComponent) {
    @Ref() readonly statisticalAnalysisExternalViewsIncidentsStatisticsModal!: BModal
    @Prop() readonly externalInfo!: StatisticalAnalysisIncidentsDossierExternalInfo
    stateExternalList!:StatisticAnalysisExternalViewIncidentsStatisticsState
    instanceDatasource!: StatisticalAnalysisHandlerDatasourceIncidentsDossierGeneralList
    constructor() {
        super()
        this.stateExternalList = initialStatisticAnalysisExternalViewIncidentsStatisticsState()
    }

    get gridOptionsTable(): GridOptions {
        return {
            ...this.gridOptions,
            defaultColDef: {
                resizable: true,
                suppressMenu: true
            }
        }
    }

    get laboratoriesSelected(): LaboratoryStatisticalAnalysisSidebarDateInput[] {
        return this.stateExternalList.externalInfo?.laboratories as LaboratoryStatisticalAnalysisSidebarDateInput[]
    }

    get gridTitle(): string {
        return this.$tc(this.stateExternalList.externalInfo?.trackingGeneralSelected?.label as string)
    }

    get typeCase(): string {
        const texts = (this.stateExternalList?.externalInfo?.typeSearch as StatisticalAnalysisSidebarItemCombo[]).map((item: StatisticalAnalysisSidebarItemCombo) => this.$tc(item.text, 2))
        return texts?.join(', ')
    }

    get startDate(): Date {
        return this.stateExternalList.externalInfo?.startDate as Date
    }

    get endDate(): Date {
        return this.stateExternalList.externalInfo?.endDate as Date
    }

    get totalElements(): string {
        if (this.state.totalElements) {
            return Formatter.number(this.state.totalElements)
        }
        return '-'
    }

    get tooltipButton(): string {
        const tooltip = this.$tc(
            'statisticalAnalysis.dossiers.lists.entityList',
            1,
            { entity:
                this.externalInfo?.typeSearch!.length > 1
                    ? `(${this.externalInfo?.typeSearch?.map((item:StatisticalAnalysisSidebarItemCombo) => this.$tc(item.text, 2))?.join(', ') as string})`
                    : `${this.externalInfo?.typeSearch?.map((item:StatisticalAnalysisSidebarItemCombo) => this.$tc(item.text, 2))?.join(', ') as string}`
            })
        return Formatter.capitalize(tooltip)
    }

    onHide(): void {
        this.state.totalElements = null
        this.instanceDatasource.setTotalElements(null)
    }

    onChangedMode(mode: any): void {
        this.changedMode(mode)
    }

    onChangedPageSize(size: number): void {
        this.changedPageSize(size)
    }

    onOpenDetailList(): void {
        this.deselectAll()
        this.stateExternalList.externalInfo = this.externalInfo
        this.instanceDatasource = new StatisticalAnalysisHandlerDatasourceIncidentsDossierGeneralList(this.stateExternalList.externalInfo)
        this.state.datasource.service = this.instanceDatasource
        this.state.columnsDef = this.instanceDatasource.getGridColumns()
        this.statisticalAnalysisExternalViewsIncidentsStatisticsModal.show()
    }

    onEndCallback(_event: AgGridCallbackEvent) {
        this.state.totalElements = this.instanceDatasource.getTotalElements()
    }

    exportReport(exportType: CommonExportType): Promise<AxiosResponse<Blob>> | null {
        const columns = this.getColumnsToExport()
        if (columns) {
            const selectedRows = this.state.selectedRows
            const selectedIds = selectedRows.map(selectedRow => selectedRow.incidentId)
            const entityIdentifiersRequest: EntityIdentifiersRequest = {
                entityIdentifiers: selectedIds
            }

            const request: ReportGridRequest = {
                sectionLabel: this.gridTitle,
                columns: columns.filter((columnFiltered: GridColumnRequest) => {
                    const columnsNotIncluded = ['notifiedPersonnel', 'notifiedResponsibilities']
                    if (!includes(columnsNotIncluded, columnFiltered.field)) {
                        return columnFiltered
                    }
                }),
                entityIdentifiersRequest
            }
            const entityTypes = this.externalInfo.typeSearch!.map((item:StatisticalAnalysisSidebarItemCombo) => item.id as StatiscalAnalysisTypeCases)
            return incidentsStatisticsDossierService.generalExportTo(this.externalInfo, request, entityTypes, exportType)
        }
        return null
    }

    private async _downloadAPA(row: StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent): Promise<void> {
        const [labId, caseId] = (this.state.datasource.service as StatisticalAnalysisDatasourceExternalDetail<StatisticalAnalysisDossiersDatasourceResponsesDetailTypes>).getLabAndCaseId(row)
        if (caseId) {
            let includeAssociated = false
            if (await this._hasAssociatedCases(labId, caseId)) {
                includeAssociated = await this.$_showConfirmationModal(this.$t('global.modal.case.viewAssociatedCasesConfirmation') as string)
            }
            this.$_updateLoading(true)
            const blob = await this.$_toCallSecure(registryCasePrintService.downloadCaseAPReportPdf(labId, caseId, includeAssociated))
            if (blob) {
                this.$_openFile({ blob })
            }
            this.$_updateLoading(false)
        }
    }

    private async _hasAssociatedCases(labId:number, caseId:number):Promise<boolean> {
        const response = await this.$_toCallSecure(commonCaseServices.getAssociatedCases(labId, caseId))
        return !!response?.length
    }
}
